import timezoneMap from '../timezone-short-name-map.json' with { type: 'json' };
import { isSameDayInTimezone } from './get-timezone-offset-milliseconds';

export const isDateTodayInTimeZone = (startDateNumeric: number, timeZone: keyof typeof timezoneMap): boolean => {
  const now = new Date().getTime();

  return isSameDayInTimezone(startDateNumeric, now, timeZone);
};
